/**
 * PDF remito de compra: después de Guardar Parcial o Finalizar (como ventas).
 * Parcial/Finalizar se muestran mientras el remito está en trabajo (pendiente
 * o parcial), no se ocultan cuando ya hay PDF.
 */

export function remitoCompraTienePdf(remito: {
  estado?: string | null;
  pdfSnapshots?: unknown[] | null;
  pdf_snapshots?: unknown[] | null;
  pdfUrl?: string | null;
  pdf_url?: string | null;
}): boolean {
  const estado = String(remito.estado || "").toLowerCase();
  if (estado === "parcial" || estado === "finalizado" || estado === "pagado" || estado === "parcial_pago") {
    return true;
  }
  const snaps = remito.pdfSnapshots ?? remito.pdf_snapshots ?? [];
  if (Array.isArray(snaps) && snaps.length > 0) return true;
  const url = remito.pdfUrl ?? remito.pdf_url;
  return Boolean(url && String(url).trim());
}

export function remitoCompraPdfEsFinal(estado?: string | null): boolean {
  const s = String(estado || "").toLowerCase();
  return s === "finalizado" || s === "entregado" || s === "pagado";
}

export function remitoCompraEsHistorico(estado?: string | null): boolean {
  const s = String(estado || "").toLowerCase();
  return s === "finalizado" || s === "pagado" || s === "parcial_pago" || s === "recibido";
}

export function remitoCompraEsTrabajo(estado?: string | null): boolean {
  return !remitoCompraEsHistorico(estado);
}
